/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Voice_Manager_Unpin_LabelInputs */



/**
* | output |
* | --- |
* | "Unpin {name}" |
*
* @param {Voice_Manager_Unpin_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_unpin_label = /** @type {((inputs: Voice_Manager_Unpin_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Unpin_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Depingler ${i?.name}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name} entriegeln`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Sblocca ${i?.name}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Открепить ${i?.name}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Desanclar ${i?.name}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`取消固定${i?.name}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.name} のピンを外す`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.name} को अनपिन करें`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Desafixar ${i?.name}`)
	return /** @type {LocalizedString} */ (`Unpin ${i?.name}`)
});